import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import { initializeEnvironmentValidation } from './utils/envValidation'
import { queryClient } from './lib/queryClient'
import { ThemeProvider } from './contexts/ThemeContext'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

try {
  initializeEnvironmentValidation()

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ThemeProvider>
    </React.StrictMode>,
  )
} catch (error) {
  console.error('Failed to render app:', error)
  rootElement.innerHTML = `
    <div style="padding: 20px; text-align: center; font-family: Arial, sans-serif;">
      <h1>Care Quote</h1>
      <p>Loading application...</p>
      <p style="color: red;">If this persists, please check the console for errors.</p>
    </div>
  `
}
